import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/material';
import { useRef, useState } from 'react';
import { useRootStore } from '../hooks/useRootStore';
import { getIssueScoreNameRu, IssueScore } from '../data/IssueScore';
import Slider from '@mui/material/Slider';
import { MDXEditor, MDXEditorMethods } from '@mdxeditor/editor';
import { MdxPlugins } from './MarkdownEditor/MarkdownEditorPlugins';

function valuetext(value: number) {
    return `${value}°C`;
}

export default function RateIssueDialog({ issueId, onSubmit, onCancel }: { issueId: number, onSubmit: (score: IssueScore) => void, onCancel: () => void }) {
    const [score, setScore] = useState<IssueScore>(IssueScore.eight);
    const { api } = useRootStore();

    const completeIssue = async (scoreID: IssueScore) => {
        const comments = (mdxEditorRef.current?.getMarkdown() ?? '')
        await api.completeIssue(issueId, scoreID, comments).then(() => onSubmit(scoreID));
    }

    const handleSliderChange = (_event: Event, newValue: number | number[]) => {
        setScore(newValue as number);
    };

    const mdxEditorRef = useRef<MDXEditorMethods>(null);

    return (
        <Box>
            <Dialog open={true} onClose={onCancel} maxWidth='xl'>
                <DialogTitle>Завершение задачи</DialogTitle>
                <DialogContent sx={{ p: 5 }}>                    
                    <Box sx={{ width: 500, mt: 2 }}>
                        <span>Оценка: </span>
                        <span><b>{getIssueScoreNameRu(score)}</b></span>
                    </Box>
                    <Box sx={{ width: 1000, pl: 0, mt: 7,  }}>
                        <Slider
                            aria-label="Оценка"
                            value={score as number}
                            getAriaValueText={valuetext}
                            valueLabelDisplay="auto"
                            onChange={handleSliderChange}
                            step={1}
                            marks
                            min={1}
                            max={10}
                        />
                    </Box>
                    <Box sx={{ mt: 2 }} >
                        Комментарий:
                        <Box sx={{ width: 1000, mt: 2, height: 300, border: '1px solid #cccccc' }} onClick={() => mdxEditorRef.current?.focus()}>                        
                            <MDXEditor
                                ref={mdxEditorRef}
                                markdown={''}
                                plugins={MdxPlugins.standardPlugins(api, issueId)}
                            />
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancel}>Отмена</Button>
                    <Button onClick={() => completeIssue(score as IssueScore)}>Завершить задачу</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}